import React from "react";
import {
  EntityDetailProps,
  getEntityTypeEntry,
} from "../../types/entityRegistry";
import { EntityDetailComingSoon } from "./EntityDetailStatus";
import { ENTITY_DETAIL_VIEWS, UntypedEntityDetail } from "./entityDetailViews";

interface EntityDetailDispatcherProps extends EntityDetailProps {
  // The singular type key of the entity, when the caller knows it.
  // Without it the id names an organization, facility, project or source,
  // and which of them is told from the fetched response.
  entityType?: string;
}

/**
 * The one entry point for showing an entity's detail.
 * Looks the type up in the registry and renders its Detail component from
 * the views map; that component fetches its own data and shows its own
 * loading, error and not-found states through EntityDetailStatus.
 */
const EntityDetail: React.FC<EntityDetailDispatcherProps> = ({
  entityId,
  entityType,
  mode = "overlay",
  onEntityClick,
  onClose,
  scrollContainerRef,
}) => {
  if (!entityId) return null;

  let Detail = UntypedEntityDetail;
  if (entityType !== undefined) {
    const entry = getEntityTypeEntry(entityType);
    if (!entry) {
      return <EntityDetailComingSoon entityType={entityType} />;
    }
    Detail = ENTITY_DETAIL_VIEWS[entry.key];
  }

  return (
    <Detail
      entityId={entityId}
      mode={mode}
      onEntityClick={onEntityClick}
      onClose={onClose}
      scrollContainerRef={scrollContainerRef}
    />
  );
};

export default EntityDetail;
